<template>
    <v-col
        :cols="width"
    >
        <v-textarea
            :disabled="readonly"
            :label="inputLabel"
            :name="item.name"
            :rules="rules"
            ref="input"
            :rows="`${item.props.maxLength && item.props.maxLength > 300 ? '6' : '4'}`"
            v-model="modelData"
            :counter="!!item.props.maxLength"
            :maxlength="item.props.maxLength"
            :persistent-hint="!!item.props.hint"
            :hint="item.props.hint"
            outlined >

            <template v-if="item.props.tooltip" v-slot:append-outer>
                <v-tooltip
                    top
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information</v-icon>
                    </template>
                    <div v-html="item.props.tooltip"></div>
                </v-tooltip>
            </template>

        </v-textarea>
    </v-col>
</template>
<script>
    export default {
        name: 'TextArea',

        props: {
            item: Object,
            value: [String, Number],
            readonly: Boolean,
            rules: Array,
            width: [String, Number],
            handleTabChange: Function
        },

        computed: {
            modelData: {
                get: function () {
                    return this.value;
                },
                set: function (newVal) {
                    this.$emit('input', newVal);
                }
            },
            inputLabel: function () {
                return this.item.props && this.item.props.label;
            }
        },

        methods: {
            validate: function () {
                return this.$refs.input.validate();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/questionnaire_template/text-area.vue